module.exports = __webpack_public_path__ + "img/7b5078b.jpg";